
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"7.998","cy":"7.998","r":"2.084","fill":"#24a4ec","stroke":"#262626","stroke-width":".5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.486 7.998h-.49M12.51 7.998H13M7.998 12.51V13M7.998 3.486v-.49M4.808 11.188l-.348.347M11.188 4.808l.347-.348M11.188 11.188l.347.347M4.808 4.808L4.46 4.46","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    